import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { saveCartItemsAPI } from "../../service/cart.service";
import InventoryTemplate from "./inventory.template";
import {
  getInventoryFilterAPI,
  getInventorySearchAPI,
  getInventorySmartFilterCountAPI,
} from "../Home-Page/home-page.component.service";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { addToCart } from "../../reducers/cart.reducer";
import { getProductPrice } from "../../utils/cart.utils";

const InventoryComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.app);
  const { cart } = useSelector((state) => state.app);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(10);
  const { uniqueId } = useParams();
  const [selectedSmartFilters, setSelectedSmartFilters] = useState([]);
  const [specFilters, setSpecFilters] = useState([]);
  const [resetFilters, setResetFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const MySwal = withReactContent(Swal);
  console.log({ user, cart });

  const onLoad = async (page = 1) => {
    try {
      setLoading(true);
      setError(null);
      const skip = (page - 1) * itemsPerPage;
      const limit = itemsPerPage;

      const response = await getInventorySearchAPI(
        {
          keyword: searchTerm,
          uniqueId: uniqueId,
          filters: selectedSmartFilters,
        },
        "createdAt",
        "desc",
        skip,
        limit
      );

      if (response.status) {
        setInventoryItems(response.data || []);
        const totalItems = response.data?.count || 0;
        setTotalPages(Math.ceil(totalItems / itemsPerPage));
        setCurrentPage(page);
      } else {
        setError(response.message || "Failed to fetch inventory items");
      }
    } catch (err) {
      console.error("Error:", err);
      setError("An error occurred while fetching inventory items");
    } finally {
      setLoading(false);
    }
  };

    const saveCartItems = async () => {
    const cartData = cart.map((item) => {
      const selected_price = getProductPrice(item);
      return {
        ...item,
        alternate_packaging: [],
        selected_price: selected_price,
        actual_price: selected_price,
        total_amount: selected_price * item.required_qty,
      };
    });

    const payload = {
      cart: cartData,
    };

    const saveResp = await saveCartItemsAPI(payload);

    return saveResp;
  };

  const handleAddToCart = async (product) => {
    // Check if user is logged in
    if (!user) {
      // Redirect to login page with a return URL
      navigate("/login", { state: { from: window.location.pathname } });
      return;
    }

    // Create a clean version of cart data with only necessary fields
    console.log({ cart });
    const cartData = cart.map((item) => {
      console.log({ item });
      const selected_price = getProductPrice(item);
      return {
        product_id: item.id,
        part_number: item.part_number,
        name: item.name,
        description: item.description,
        brand: item.brand,
        model: item.model,
        category: item.category,
        sub_category: item.sub_category,
        price: item.price,
        image: item.image,
        required_qty: item.required_qty || 1,
        alternate_packaging: [],
        selected_price: selected_price,
        actual_price: selected_price,
        total_amount: selected_price * (item.required_qty || 1),
      };
    });

    try {
      // Save cart item to database
      const response = await saveCartItemsAPI({
        cart: cartData,
        customer_id: user.id,
      });

      if (response.status) {
        console.log("Item added to cart successfully", response.data);
        // Optionally update the local cart state if needed
      } else {
        console.error("Failed to add item to cart:", response.message);
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
    }

    // Normalize price object if it's an array
    let priceObj = product.price;

    if (Array.isArray(product.price)) {
      const sortedSlabs = [...product.price].sort(
        (a, b) => parseInt(a.slab) - parseInt(b.slab)
      );

      priceObj = {
        min_order: parseInt(sortedSlabs[0]?.slab || 1),
        multiple: parseInt(sortedSlabs[0]?.slab || 1),
        price_list: sortedSlabs.map((slab) => ({
          min_qty: parseInt(slab.slab),
          price: parseFloat(slab.price),
        })),
      };
    }

    let requiredQty = product.required_qty || priceObj.min_order;
    let multiple = priceObj.multiple || 1;

    // Check if required quantity is greater than available quantity
    if (requiredQty > product.available_qty) {
      // Use partner's min and multiple quantities
      const partnerMinQty = parseInt(product.partner_min_qty) || 1;
      const partnerMulQty = parseInt(product.partner_mul_qty) || 1;

      // Calculate the minimum valid quantity based on partner's requirements
      const minValidQty = Math.max(
        partnerMinQty,
        Math.ceil(requiredQty / partnerMulQty) * partnerMulQty
      );

      // Update required quantity and multiple
      requiredQty = minValidQty;
      multiple = partnerMulQty;

      // Show a message to the user
      MySwal.fire({
        title: <strong>Quantity Adjusted</strong>,
        html: (
          <i>
            Your requested quantity exceeds available stock. Adjusted to{" "}
            {requiredQty} based on partner's minimum ({partnerMinQty}) and
            multiple ({partnerMulQty}) quantities.
          </i>
        ),
        icon: "info",
      });
    }
    // Validate quantity is a multiple of the defined multiple
    else if (requiredQty % multiple !== 0) {
      MySwal.fire({
        title: <strong>Invalid Quantity</strong>,
        html: <i>Please enter a quantity in multiples of {multiple}.</i>,
        icon: "warning",
      });
      return;
    }

    const cartProduct = {
      ...product,
      required_qty: requiredQty,
      manufacturer: product.make,
      price: priceObj,
    };

    console.log({ product, cartProduct });

    MySwal.fire({
      title: <strong>Cart Update!</strong>,
      html: <i>You've added {product.part_number} to your cart </i>,
      icon: "success",
    });

    dispatch(addToCart(cartProduct));
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onLoad(newPage);
      window.scrollTo(0, 0);
    }
  };

  // Load data when component mounts or when dependencies change
  useEffect(() => {
    onLoad(1);
  }, [uniqueId, searchTerm, selectedSmartFilters, itemsPerPage]);

  const onSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    setCurrentPage(1);
    onLoad(1);
  };

  const clearSearch = () => {
    setSearchTerm("");
    setCurrentPage(1);
    onLoad(1);
  };

  const handleFilterChange = async (specId, specName, event) => {
    // console.log({ specId, specName, event: event.target.value });

    const specValue = event.target.value;

    let copySmartFilters = [...selectedSmartFilters];

    const findIndex = copySmartFilters.findIndex(
      (filter) => filter.spec_id === specId
    );

    if (findIndex >= 0)
      copySmartFilters[findIndex] = {
        ...copySmartFilters[findIndex],
        spec_value: specValue,
      };
    else {
      copySmartFilters.push({
        spec_id: specId,
        spec_value: specValue,
      });
    }

    setSelectedSmartFilters(copySmartFilters);
  };

  const handleApplyFilter = async () => {
    onLoad(searchTerm, uniqueId);
  };

  const handleResetAll = () => {
    setSelectedFilters({});
    setSelectedSmartFilters([]);
    setResetFilters((prev) => !prev); // Toggle to ensure it triggers the effect
  };

  // Handle reset when resetFilters changes
  useEffect(() => {
    if (resetFilters) {
      onLoad(searchTerm, uniqueId);
      setResetFilters(false); // Reset the flag after handling
    }
  }, [resetFilters, searchTerm, uniqueId]);

  const inventoryFilter = async () => {
    const payload = {
      uniqueId: uniqueId,
      filters: selectedSmartFilters,
    };

    // console.log({ categoryId, payload });

    const apiFilter = await getInventoryFilterAPI(uniqueId);
    console.log({ apiFilter });
    if (apiFilter.status && apiFilter.data) {
      const countRes = await getInventorySmartFilterCountAPI(payload);

      let specData = apiFilter.data;

      // console.log({ data: apiFilter.data, countRes, specData });

      const updatedFilters = [];

      for (let i = 0; i < specData.spec_values.length; i++) {
        const filteredValue = countRes.data?.find(
          (spec) => spec.spec_id === specData.spec_values[i].specification_id
        );
        let filterData = {
          ...specData.spec_values[i],
          values: filteredValue?.values || [],
        };
        updatedFilters.push(filterData);
      }

      // console.log({ updatedFilters });

      setSpecFilters({ ...apiFilter.data, spec_values: updatedFilters });
    }
  };

  useEffect(() => {
    // console.log({ selectedSmartFilters });
    if (uniqueId) inventoryFilter();
  }, [selectedSmartFilters, uniqueId]);

  const handleRemoveChip = (specId) => {
    setSelectedSmartFilters((prev) => prev.filter((f) => f.spec_id !== specId));

    const selectBox = document.querySelector(`select[data-specid="${specId}"]`);
    if (selectBox) {
      Array.from(selectBox.options).forEach((opt) => {
        opt.selected = false;
      });
    }
  };

  const handleClickPartNumber = (partNumber) => {
    // console.log({ partNumber });
    navigate(`/product/${partNumber}`);
  };

  const templateData = {
    inventoryItems,
    loading,
    error,
    searchTerm,
    currentPage,
    totalPages,
    specFilters,
    selectedSmartFilters,
  };

  const templateEvent = {
    onLoad,
    onSearchChange,
    handleSearch,
    clearSearch,
    handleFilterChange,
    handleApplyFilter,
    handleResetAll,
    handleRemoveChip,
    handlePageChange,
    handleClickPartNumber,
    handleAddToCart,
  };

  return (
    <InventoryTemplate
      templateData={templateData}
      templateEvent={templateEvent}
    />
  );
};

export default InventoryComponent;
